import { Columns, Column, Card, Box, Stack } from 'braid-design-system';
import type React from 'react';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import HooraySvg from 'src/images/Hooray.svg';

interface PaymentSuccessLayoutProps {
  callToAction: React.ReactNode;
  children: React.ReactNode;
}

export const PaymentSuccessLayout = ({
  callToAction,
  children,
}: PaymentSuccessLayoutProps) => (
  <Columns space="small" collapseBelow="desktop">
    <Column width="3/5">
      <Card>
        <Stack space="large">
          <Box>{children}</Box>

          <Box>{callToAction}</Box>
        </Stack>
      </Card>
    </Column>

    <Column>
      <Box padding="xxlarge">
        <CustomSvg svg={HooraySvg} />
      </Box>
    </Column>
  </Columns>
);
